import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "space-y-4 flex min-h-0 flex-1 flex-col"
};
const _hoisted_2 = {
  class: "grid gap-3 md:grid-cols-4"
};
const _hoisted_3 = {
  class: "text-xs font-medium text-slate-500"
};
const _hoisted_4 = {
  class: "mt-1 text-xl font-semibold text-slate-900"
};
const _hoisted_5 = {
  class: "list-page-table-panel list-page-table-panel--fill"
};
const _hoisted_6 = {
  class: "data-table-shell border-none shadow-none"
};
const _hoisted_7 = {
  class: "data-table-scroll data-table-scroll--fill"
};
const _hoisted_8 = {
  class: "data-table text-sm min-w-[960px]"
};
const _hoisted_9 = {
  key: 0,
  class: "data-table-row"
};
const _hoisted_10 = {
  key: 1,
  class: "data-table-row"
};
const _hoisted_11 = {
  class: "data-table-td min-w-[220px]"
};
const _hoisted_12 = {
  class: "data-table-cell-title"
};
const _hoisted_13 = {
  class: "data-table-cell-meta"
};
const _hoisted_14 = {
  class: "data-table-td font-mono text-xs text-slate-600"
};
const _hoisted_15 = {
  class: "data-table-td"
};
const _hoisted_16 = ["title"];
const _hoisted_17 = {
  class: "data-table-td whitespace-nowrap text-slate-600"
};
const _hoisted_18 = {
  class: "data-table-td whitespace-nowrap text-slate-600"
};
const _hoisted_19 = {
  class: "data-table-td is-center whitespace-nowrap data-table-sticky-right data-table-sticky-action"
};
const _hoisted_20 = {
  class: "flex items-center justify-center gap-1"
};
const _hoisted_21 = ["onClick"];
const _hoisted_22 = ["onClick"];
const _hoisted_23 = {
  key: 0,
  class: "space-y-5"
};
const _hoisted_24 = {
  class: "rounded-2xl border border-slate-200 p-4"
};
const _hoisted_25 = {
  class: "mt-4 grid grid-cols-2 gap-3 text-sm"
};
const _hoisted_26 = {
  class: "mt-1 text-slate-900"
};
const _hoisted_27 = {
  class: "mt-1 text-slate-900"
};
const _hoisted_28 = {
  class: "mt-1 font-mono text-xs"
};
const _hoisted_29 = {
  class: "mt-1"
};
const _hoisted_30 = {
  class: "rounded-2xl border border-slate-200 p-4"
};
const _hoisted_31 = {
  class: "mt-3 text-sm text-slate-600"
};
const _hoisted_32 = {
  class: "rounded-2xl border border-slate-200 p-4"
};
const _hoisted_33 = {
  class: "mt-3 max-h-64 overflow-auto rounded-xl bg-slate-950 p-4 text-xs leading-5 text-slate-100"
};
const _hoisted_34 = {
  class: "rounded-2xl border border-slate-200 p-4"
};
const _hoisted_35 = {
  class: "mt-3 max-h-80 overflow-auto rounded-xl bg-slate-950 p-4 text-xs leading-5 text-slate-100"
};
import { computed, onMounted, reactive, ref } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import AppPagination from '@/components/AppPagination.vue';
import ListPageShell from '@/components/ListPageShell.vue';
import PageFilterBar from '@/components/PageFilterBar.vue';
import { getEsignCallbackLogPage, retryEsignCallbackLog } from '@/api/esign';
import { blank, formatDateTime, normalizePage, processStatusText, safeJson, statusClassByResult } from './esign-utils';
export default {
  __name: 'EsignCallbackLogManagement',
  setup(__props) {
    const loading = ref(false);
    const list = ref([]);
    const detail = ref(null);
    const detailVisible = ref(false);
    const filters = reactive({
      eventId: '',
      eventType: '',
      tencentFlowId: '',
      processStatus: ''
    });
    const pagination = ref({
      current: 1,
      size: 10,
      total: 0,
      pages: 1
    });
    const summaryCards = computed(() => [{
      label: '当前页日志',
      value: list.value.length
    }, {
      label: '成功',
      value: list.value.filter(item => item.processStatus === 'SUCCESS').length
    }, {
      label: '失败',
      value: list.value.filter(item => item.processStatus === 'FAILED').length
    }, {
      label: '待处理',
      value: list.value.filter(item => item.processStatus === 'PENDING').length
    }]);
    const fetchList = async () => {
      loading.value = true;
      try {
        const res = await getEsignCallbackLogPage({
          current: pagination.value.current,
          size: pagination.value.size,
          ...filters
        });
        const page = normalizePage(res, pagination.value);
        list.value = page.records;
        pagination.value = page.pagination;
      } catch (error) {
        ElMessage.error(error.message || '加载回调日志失败');
      } finally {
        loading.value = false;
      }
    };
    const handleSearch = () => {
      pagination.value.current = 1;
      fetchList();
    };
    const handleReset = () => {
      Object.assign(filters, {
        eventId: '',
        eventType: '',
        tencentFlowId: '',
        processStatus: ''
      });
      handleSearch();
    };
    const handlePageChange = page => {
      pagination.value.current = page;
      fetchList();
    };
    const handlePageSizeChange = size => {
      pagination.value.size = size;
      pagination.value.current = 1;
      fetchList();
    };
    const openDetail = item => {
      detail.value = item;
      detailVisible.value = true;
    };
    const retryLog = async item => {
      await ElMessageBox.confirm('确认重放这条回调日志吗？重放会再次执行回调处理逻辑。', '重放回调', {
        type: 'warning',
        confirmButtonText: '确认重放',
        cancelButtonText: '取消'
      });
      try {
        await retryEsignCallbackLog(item.id);
        ElMessage.success('回调重放已提交');
        fetchList();
      } catch (error) {
        ElMessage.error(error.message || '回调重放失败');
      }
    };
    onMounted(fetchList);
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_drawer = _resolveComponent("el-drawer");
      return _openBlock(), _createBlock(ListPageShell, {
        fill: ""
      }, {
        header: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createElementVNode("div", {
          class: "list-page-panel is-header-minimal"
        }, [_createElementVNode("div", null, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "电子签回调日志"), _createElementVNode("p", {
          class: "mt-2 text-sm leading-6 text-slate-600"
        }, "查看腾讯电子签回调原文、处理结果和失败重放记录，用于排查签署状态同步问题。")])], -1)]))]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(summaryCards.value, item => {
          return _openBlock(), _createElementBlock("div", {
            key: item.label,
            class: "rounded-2xl border border-slate-200 bg-white p-3 shadow-sm"
          }, [_createElementVNode("p", _hoisted_3, _toDisplayString(item.label), 1), _createElementVNode("p", _hoisted_4, _toDisplayString(item.value), 1)]);
        }), 128))]), _createElementVNode("div", _hoisted_5, [_createVNode(PageFilterBar, {
          "shell-class": "filter-bar-shell is-embedded",
          "body-class": "filter-bar-body is-panel",
          "show-refresh": true,
          "refresh-loading": loading.value,
          onRefresh: fetchList
        }, {
          searchActions: _withCtx(() => [_createElementVNode("button", {
            class: "btn-primary",
            type: "button",
            onClick: handleSearch
          }, "搜索"), _createElementVNode("button", {
            class: "btn-secondary",
            type: "button",
            onClick: handleReset
          }, "重置")]),
          default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => filters.eventId = $event),
            class: "form-input form-control-sm filter-bar-field",
            placeholder: "事件 ID"
          }, null, 512), [[_vModelText, filters.eventId]]), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => filters.eventType = $event),
            class: "form-input form-control-sm filter-bar-field",
            placeholder: "事件类型"
          }, null, 512), [[_vModelText, filters.eventType]]), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => filters.tencentFlowId = $event),
            class: "form-input form-control-sm filter-bar-field",
            placeholder: "腾讯 FlowId"
          }, null, 512), [[_vModelText, filters.tencentFlowId]]), _createVNode(_component_el_select, {
            modelValue: filters.processStatus,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => filters.processStatus = $event),
            placeholder: "请选择状态",
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部状态",
              value: ""
            }), _createVNode(_component_el_option, {
              label: "待处理",
              value: "PENDING"
            }), _createVNode(_component_el_option, {
              label: "成功",
              value: "SUCCESS"
            }), _createVNode(_component_el_option, {
              label: "失败",
              value: "FAILED"
            }), _createVNode(_component_el_option, {
              label: "已忽略",
              value: "IGNORED"
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }, 8, ["refresh-loading"]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("table", _hoisted_8, [_cache[8] || (_cache[8] = _createElementVNode("thead", {
          class: "data-table-head"
        }, [_createElementVNode("tr", null, [_createElementVNode("th", {
          class: "data-table-th text-left"
        }, "事件"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "腾讯 FlowId"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "处理状态"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "处理信息"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "接收时间"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "处理时间"), _createElementVNode("th", {
          class: "data-table-th is-center data-table-sticky-right data-table-sticky-head data-table-sticky-action"
        }, "操作")])], -1)), _createElementVNode("tbody", null, [loading.value ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [...(_cache[6] || (_cache[6] = [_createElementVNode("td", {
          colspan: "7",
          class: "data-table-empty"
        }, "正在加载回调日志...", -1)]))])) : !list.value.length ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [...(_cache[7] || (_cache[7] = [_createElementVNode("td", {
          colspan: "7",
          class: "data-table-empty"
        }, "暂无回调日志", -1)]))])) : (_openBlock(true), _createElementBlock(_Fragment, {
          key: 2
        }, _renderList(list.value, item => {
          return _openBlock(), _createElementBlock("tr", {
            key: item.id,
            class: "data-table-row"
          }, [_createElementVNode("td", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString(item.eventType || '-'), 1), _createElementVNode("div", _hoisted_13, _toDisplayString(item.eventId || item.id), 1)]), _createElementVNode("td", _hoisted_14, _toDisplayString(_unref(blank)(item.tencentFlowId)), 1), _createElementVNode("td", _hoisted_15, [_createElementVNode("span", {
            class: _normalizeClass(['status-badge', _unref(statusClassByResult)(item.processStatus)])
          }, _toDisplayString(_unref(processStatusText)(item.processStatus)), 3)]), _createElementVNode("td", {
            class: "data-table-td max-w-[260px] truncate text-slate-600",
            title: item.processMessage
          }, _toDisplayString(_unref(blank)(item.processMessage)), 9, _hoisted_16), _createElementVNode("td", _hoisted_17, _toDisplayString(_unref(formatDateTime)(item.receivedTime) || '-'), 1), _createElementVNode("td", _hoisted_18, _toDisplayString(_unref(formatDateTime)(item.processedTime) || '-'), 1), _createElementVNode("td", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("button", {
            class: "table-action-button is-primary",
            onClick: $event => openDetail(item)
          }, "详情", 8, _hoisted_21), item.processStatus === 'FAILED' ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "table-action-button is-danger",
            onClick: $event => retryLog(item)
          }, "重放", 8, _hoisted_22)) : _createCommentVNode("", true)])])]);
        }), 128))])])])]), _createVNode(AppPagination, {
          class: "pagination-bridge",
          pagination: pagination.value,
          "page-sizes": [10, 20, 50],
          onPageChange: handlePageChange,
          onSizeChange: handlePageSizeChange
        }, null, 8, ["pagination"])])]), _createVNode(_component_el_drawer, {
          modelValue: detailVisible.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => detailVisible.value = $event),
          title: "回调详情",
          size: "760px"
        }, {
          default: _withCtx(() => [detail.value ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createElementVNode("section", _hoisted_24, [_cache[13] || (_cache[13] = _createElementVNode("h3", {
            class: "text-sm font-semibold text-slate-900"
          }, "基础信息", -1)), _createElementVNode("dl", _hoisted_25, [_createElementVNode("div", null, [_cache[9] || (_cache[9] = _createElementVNode("dt", {
            class: "text-slate-500"
          }, "事件 ID", -1)), _createElementVNode("dd", _hoisted_26, _toDisplayString(detail.value.eventId || detail.value.id), 1)]), _createElementVNode("div", null, [_cache[10] || (_cache[10] = _createElementVNode("dt", {
            class: "text-slate-500"
          }, "事件类型", -1)), _createElementVNode("dd", _hoisted_27, _toDisplayString(detail.value.eventType || '-'), 1)]), _createElementVNode("div", null, [_cache[11] || (_cache[11] = _createElementVNode("dt", {
            class: "text-slate-500"
          }, "腾讯 FlowId", -1)), _createElementVNode("dd", _hoisted_28, _toDisplayString(_unref(blank)(detail.value.tencentFlowId)), 1)]), _createElementVNode("div", null, [_cache[12] || (_cache[12] = _createElementVNode("dt", {
            class: "text-slate-500"
          }, "处理状态", -1)), _createElementVNode("dd", _hoisted_29, _toDisplayString(_unref(processStatusText)(detail.value.processStatus)), 1)])])]), _createElementVNode("section", _hoisted_30, [_cache[14] || (_cache[14] = _createElementVNode("h3", {
            class: "text-sm font-semibold text-slate-900"
          }, "处理信息", -1)), _createElementVNode("p", _hoisted_31, _toDisplayString(_unref(blank)(detail.value.processMessage)), 1)]), _createElementVNode("section", _hoisted_32, [_cache[15] || (_cache[15] = _createElementVNode("h3", {
            class: "text-sm font-semibold text-slate-900"
          }, "Raw Headers", -1)), _createElementVNode("pre", _hoisted_33, _toDisplayString(_unref(safeJson)(detail.value.rawHeaders) || '-'), 1)]), _createElementVNode("section", _hoisted_34, [_cache[16] || (_cache[16] = _createElementVNode("h3", {
            class: "text-sm font-semibold text-slate-900"
          }, "Raw Body", -1)), _createElementVNode("pre", _hoisted_35, _toDisplayString(_unref(safeJson)(detail.value.rawBody) || '-'), 1)])])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      });
    };
  }
};